import type {AnalyticsGenesisActions} from 'src/action-creators/analytics-genesis';
import type {
  ProductCatalogItem,
  SelectedProduct,
} from 'src/types/analytics-genesis';

import {
  RECEIVE_PRODUCT_CATALOG_LIST,
  RECEIVE_CURRENT_PRODUCT_LIST_ITEM,
} from 'src/action-creators/analytics-genesis';


export type State = {
  productCatalogList: Array<ProductCatalogItem>;
  currentProductListItem: SelectedProduct | null;
};

const initialState = {
  productCatalogList: [],
  currentProductListItem: null,
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly productCatalogList: readonly []; readonly currentProductListItem: null; }' is not assignable to type 'State'.
  state: State | null | undefined = initialState,
  action: AnalyticsGenesisActions,
): State => {
  switch (action.type) {
    case RECEIVE_PRODUCT_CATALOG_LIST: {
      // @ts-expect-error - TS2322 - Type '{ productCatalogList: ProductCatalogItem[]; currentProductListItem?: SelectedProduct | null | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        productCatalogList: action.payload.productCatalogList,
      };
    }
    case RECEIVE_CURRENT_PRODUCT_LIST_ITEM: {
      // @ts-expect-error - TS2322 - Type '{ currentProductListItem: SelectedProduct; productCatalogList?: ProductCatalogItem[] | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        currentProductListItem: action.payload.currentProductListItem,
      };
    }
  }

  // @ts-expect-error - TS2322 - Type 'State | null' is not assignable to type 'State'.
  return state;
};
